import { TertiaryButton } from "@coherehealth/common";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  deleteButton: {
    padding: theme.spacing(1, 2),
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.light,
    },
    "&:active": {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.dark,
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
}));

const DeleteButton = (props: React.ComponentProps<typeof TertiaryButton>) => {
  const classes = useStyles();

  return <TertiaryButton className={classes.deleteButton} {...props} />;
};

export default DeleteButton;
